<template>
    <v-row dense>
        <v-col cols="12" md="2" align-self="center" class="text-center text-no-wrap">
            <v-img :src="logoSrc" :max-height="50" cover />
            <div class="d-inline d-md-block">
                {{ segment.aircraftName }}
            </div>
            <div v-if="segment.duration" class="d-inline d-md-block">
                {{ $filters.durationFormat(segment.duration) }}
            </div>
        </v-col>
        <v-col cols="12" md="10" class="pl-0">
            <div class="pa-6 pb-4 d-flex align-center">
                <v-icon color="white" class="mr-4 pa-3 plane-icon">mdi-airplane-takeoff</v-icon>
                <div class="d-flex" :class="{'high-line': $breakpoint.smAndDown}">
                    {{ segment.departureDate ? $filters.hoursFromDate(segment.departureDate) : $t('undefined') }}
                    {{ segment.departureAirportCode }}
                    {{ segment.departureAirportDescription.airportName }}
                    {{ segment.departureAirportDescription.cityName }}
                    {{ segment.departureAirportDescription.countryName }}
                    {{ segment.departureTerminal }}
                </div>
            </div>
            <div class="ml-16 py-5">
                <v-row no-gutters>
                    <v-col v-if="segment.categoryClass" cols="12">
                        {{ $t('flights.class') }}: {{ segment.categoryClass.classType }} ({{
                            segment.categoryClass.code
                        }})
                    </v-col>
                    <v-col v-if="segment.categoryClass && segment.categoryClass.quantity" cols="12">
                        {{ $t('flights.seats') }}:
                        <span class="text-green">
                            <span v-if="+segment.categoryClass.quantity !== 9" class="text-red">
                                {{ $t('flights.seats_quantity.only') + ' ' }}
                            </span>
                            <span :class="+segment.categoryClass.quantity !== 9 ? 'text-red' : 'text-green'">
                                {{ segment.categoryClass.quantity }}
                                {{ segment.categoryClass.quantity == 9 ? '+' : '' }}
                            </span>
                            <span v-if="segment.categoryClass.quantity == 9">
                                {{ $t('flights.seats').toLowerCase() }}
                            </span>
                            <span v-else class="text-red">
                                {{
                                    $t('flights.seat', +segment.categoryClass.quantity) +
                                    ' ' +
                                    $t('flights.seats_quantity.available')
                                }}
                            </span>
                        </span>
                    </v-col>
                    <v-col v-if="segment.brandedFareName" cols="12">
                        {{ $t('flights.tariff') }}: {{ segment.brandedFareName }}
                    </v-col>
                    <v-col v-if="segment.mealCode" cols="12">
                        {{ $t('flights.meal_type') }}: {{ segment.mealCode }}
                    </v-col>
                    <v-col cols="12">
                        {{ $t('flights.flight_number') }}:
                        <span v-if="segment.marketingAirline">
                            {{ segment.marketingAirline }}
                        </span>
                        <span v-else>
                            {{ $t('no_airline_code') }}
                        </span>
                        {{ segment.flightNumber }}
                    </v-col>
                    <v-col v-if="baggageInfo" cols="12">
                        {{ $t('flights.baggage') }}:
                        {{
                            baggageInfo.unitQuantity != 0
                                ? `${$t('flights.up_to')} ${baggageInfo.unitQuantity}
                                    ${$t(`flights.baggageType.${baggageInfo.unitCode}`, +baggageInfo.unitQuantity)} `
                                : $t('flights.no_baggage')
                        }}
                    </v-col>
                </v-row>
            </div>
            <div class="pa-6 pb-4 d-flex align-center">
                <v-icon color="white" class="mr-4 pa-3 plane-icon">mdi-airplane-landing</v-icon>
                <div class="d-flex" :class="{'high-line': $breakpoint.smAndDown}">
                    {{ segment.arrivalDate ? $filters.hoursFromDate(segment.arrivalDate) : $t('undefined') }}
                    {{ segment.arrivalAirportCode }}
                    {{ segment.arrivalAirportDescription.airportName }}
                    {{ segment.arrivalAirportDescription.cityName }}
                    {{ segment.arrivalAirportDescription.countryName }}
                    {{ segment.arrivalTerminal }}
                </div>
            </div>
            <!--            <v-stepper vertical flat class="elevation-0 pb-0">-->
            <!--                <v-stepper-header>-->
            <!--                    <v-stepper-item class="" value="1" complete complete-icon="mdi-airplane-takeoff">-->
            <!--                        <div class="d-flex font-weight-light" :class="{'high-line': $breakpoint.smAndDown}">-->
            <!--                            {{-->
            <!--                                segment.departureDate ? $filters.hoursFromDate(segment.departureDate) : $t('undefined')-->
            <!--                            }}-->
            <!--                            {{ segment.departureAirportCode }}-->
            <!--                            {{ segment.departureAirportDescription.airportName }}-->
            <!--                            {{ segment.departureAirportDescription.cityName }}-->
            <!--                            {{ segment.departureAirportDescription.countryName }}-->
            <!--                            {{ segment.departureTerminal }}-->
            <!--                        </div>-->
            <!--                    </v-stepper-item>-->
            <!--                    <v-stepper-item value="2" complete complete-icon="mdi-airplane-landing">-->
            <!--                        <div class="d-flex" :class="{'high-line': $breakpoint.smAndDown}">-->
            <!--                            {{ segment.arrivalDate ? $filters.hoursFromDate(segment.arrivalDate) : $t('undefined') }}-->
            <!--                            {{ segment.arrivalAirportCode }}-->
            <!--                            {{ segment.arrivalAirportDescription.airportName }}-->
            <!--                            {{ segment.arrivalAirportDescription.cityName }}-->
            <!--                            {{ segment.arrivalAirportDescription.countryName }}-->
            <!--                            {{ segment.arrivalTerminal }}-->
            <!--                        </div>-->
            <!--                    </v-stepper-item>-->
            <!--                </v-stepper-header>-->
            <!--                <template v-slot:item.1>-->
            <!--                    <v-row no-gutters>-->
            <!--                        <v-col v-if="segment.categoryClass" cols="12">-->
            <!--                            {{ $t('flights.class') }}: {{ segment.categoryClass.classType }} ({{-->
            <!--                                segment.categoryClass.code-->
            <!--                            }})-->
            <!--                        </v-col>-->
            <!--                        <v-col v-if="segment.categoryClass && segment.categoryClass.quantity" cols="12">-->
            <!--                            {{ $t('flights.seats') }}:-->
            <!--                            <span class="text-green">-->
            <!--                                <span v-if="+segment.categoryClass.quantity !== 9" class="text-red">{{-->
            <!--                                    $t('flights.seats_quantity.only') + ' '-->
            <!--                                }}</span>-->
            <!--                                <span :class="+segment.categoryClass.quantity !== 9 ? 'red&#45;&#45;text' : 'green&#45;&#45;text'">-->
            <!--                                    {{ segment.categoryClass.quantity-->
            <!--                                    }}{{ segment.categoryClass.quantity == 9 ? '+' : '' }}-->
            <!--                                </span>-->
            <!--                                <span v-if="segment.categoryClass.quantity == 9">{{-->
            <!--                                    $t('flights.seats').toLowerCase()-->
            <!--                                }}</span>-->
            <!--                                <span v-else class="text-red">-->
            <!--                                    {{-->
            <!--                                        $t('flights.seat', +segment.categoryClass.quantity) +-->
            <!--                                        ' ' +-->
            <!--                                        $t('flights.seats_quantity.available')-->
            <!--                                    }}-->
            <!--                                </span>-->
            <!--                            </span>-->
            <!--                        </v-col>-->
            <!--                        <v-col v-if="segment.brandedFareName" cols="12">-->
            <!--                            {{ $t('flights.tariff') }}: {{ segment.brandedFareName }}-->
            <!--                        </v-col>-->
            <!--                        <v-col v-if="segment.mealCode" cols="12">-->
            <!--                            {{ $t('flights.meal_type') }}: {{ segment.mealCode }}-->
            <!--                        </v-col>-->
            <!--                        <v-col cols="12">-->
            <!--                            {{ $t('flights.flight_number') }}:-->
            <!--                            <span v-if="segment.marketingAirline">-->
            <!--                                {{ segment.marketingAirline }}-->
            <!--                            </span>-->
            <!--                            <span v-else>-->
            <!--                                {{ $t('no_airline_code') }}-->
            <!--                            </span>-->
            <!--                            {{ segment.flightNumber }}-->
            <!--                        </v-col>-->
            <!--                        <v-col v-if="baggageInfo" cols="12">-->
            <!--                            {{ $t('flights.baggage') }}:-->
            <!--                            {{-->
            <!--                                baggageInfo.unitQuantity != 0-->
            <!--                                    ? `${$t('flights.up_to')} ${baggageInfo.unitQuantity}-->
            <!--                                    ${$t(`flights.baggageType.${baggageInfo.unitCode}`, +baggageInfo.unitQuantity)} `-->
            <!--                                    : $t('flights.no_baggage')-->
            <!--                            }}-->
            <!--                        </v-col>-->
            <!--                    </v-row>-->
            <!--                </template>-->
            <!--            </v-stepper>-->
        </v-col>
    </v-row>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {fullUrl} from '~src/utils/host-adapter'

    // TODO [P1] Need check template
    @Component
    export class FlightSegmentDetail extends Vue {
        @Prop() segment

        get baggageInfo() {
            if (this.segment.baggageInfo && this.segment.baggageInfo[0]) {
                return this.segment.baggageInfo[0].baggage
            }
            return null
        }

        get logoSrc() {
            return fullUrl(`/stat/images/airlines/${this.segment.marketingAirline}.gif`)
        }
    }

    export default FlightSegmentDetail
</script>

<style lang="scss" scoped>
    .high-line {
        line-height: 18px;
    }
    .plane-icon {
        background-color: rgb(var(--v-theme-primary));
        border-radius: 50%;
    }
</style>
